// src/api/holaveciLocalApi.js
//
// D-23 — Registro y pago de HolaVeci Local.
//
//   registroLocal  → endpoints PÚBLICOS usados antes de tener sesión
//                    (OTP, geografía, categorías, legales, guía, registro).
//   documentosLocal→ subida y consulta de cédula / RUT (validación D-18).
//   pagoLocal      → pago de plan-local con el widget de Wompi.

import { api, API_BASE_URL, tokenStore } from './apiClient';

const publico = { skipAuth: true };

export const registroLocal = {
  enviarOtp: (telefono) =>
    api.post('/api/holaveci/otp/enviar', { telefono, proposito: 'registro' }, publico),
  verificarOtp: (telefono, codigo) =>
    api.post('/api/holaveci/otp/verificar', { telefono, codigo, proposito: 'registro' }, publico),

  /** Tras verificar el OTP: disponible | holaveci_negocio | holaveci_local | otra_cuenta | cuenta_cerrada. */
  verificarTelefono: (telefono) =>
    api.post('/api/holaveci/registro/local/verificar-telefono', { telefono }, publico),

  paises: () => api.get('/api/holaveci/paises', publico),
  departamentos: (paisId) => api.get('/api/holaveci/departamentos', { ...publico, query: { paisId } }),
  municipios: (departamentoId) =>
    api.get('/api/holaveci/municipios-por-departamento', { ...publico, query: { departamentoId } }),

  categorias: () => api.get('/api/holaveci/categorias-negocio', publico),

  documentoLegal: (codigo) => api.get(`/api/holaveci/legal/documentos/${encodeURIComponent(codigo)}`, publico),

  validarCodigoGuia: (codigo) =>
    api.get(`/api/holaveci/guias/validar-codigo/${encodeURIComponent(codigo)}`, publico),

  registrar: (dto) => api.post('/api/holaveci/registro/local', dto, publico),
};

export const documentosLocal = {
  misDocumentos: (empresaId) => api.get(`/api/holaveci/negocio-documentos/mis-documentos/${empresaId}`),

  subir: (empresaId, tipo, archivo) => {
    const fd = new FormData();
    fd.append('file', archivo);
    fd.append('empresaId', String(empresaId));
    fd.append('tipo', tipo);
    return api.postForm('/api/holaveci/negocio-documentos/subir', fd);
  },
};

export const pagoLocal = {
  cotizar: () => api.get('/api/pos/suscripcion-local/cotizar'),
  iniciar: () => api.post('/api/pos/suscripcion-local/iniciar', {}),
  confirmar: (referencia, wompiTransactionId) =>
    api.post('/api/pos/suscripcion-local/confirmar', { referencia, wompiTransactionId }),
  verificar: (referencia) =>
    api.get(`/api/pos/suscripcion-local/verificar/${encodeURIComponent(referencia)}`),
};

// D-24 — Mensualidad (corte día 1, plazo de pago, bloqueo por mora).
export const mensualidad = {
  /** { tieneSuscripcion, bloqueado, planCodigo, proximoCorte, factura } */
  estado: () => api.get('/api/pos/suscripcion-local/mensualidad'),
  iniciar: () => api.post('/api/pos/suscripcion-local/mensualidad/iniciar', {}),
  cuentasCobro: () => api.get('/api/pos/suscripcion-local/cuentas-cobro'),
  /** Descarga el PDF con el JWT y lo abre en otra pestaña. */
  abrirPdf: async (facturaId) => {
    const res = await fetch(`${API_BASE_URL}/api/pos/suscripcion-local/cuentas-cobro/${facturaId}/pdf`, {
      headers: { Authorization: `Bearer ${tokenStore.get()}` },
    });
    if (!res.ok) throw new Error('No se pudo descargar la cuenta de cobro.');
    const url = URL.createObjectURL(await res.blob());
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};
